export const MESSAGE_PURPOSE__REMIND_ABOUT_QUESTIONNAIRE =
  'remind_about_questionnaire';
export const MESSAGE_PURPOSE__GREET_PATIENT = 'greet_patient';
export const MESSAGE_PURPOSE__NOTIFY_ABOUT_COMPLETION =
  'notify_about_completion';
export const MESSAGE_PURPOSE__OTHER = 'other';
export const MESSAGE_PURPOSE__RESPONSES_REVIEW = 'review_responses';
export const MESSAGE_PURPOSE__SIGNUP = 'signup';
export const MESSAGE_PURPOSE__RESET_PASSWORD = 'reset_password';

// TECH-2730 / Phase 2. PEP *system* messages sent to patients by
// apps/patient-app-graphql. These are deliberately distinct from the two
// purposes above, which are the zedoc *staff* account messages: a customer
// editing "reset password" for their staff must not silently change what a
// patient receives. Neither set is a project communication.
export const MESSAGE_PURPOSE__PEP_SIGNUP = 'pep_signup';
export const MESSAGE_PURPOSE__PEP_LOGIN = 'pep_login';
export const MESSAGE_PURPOSE__PEP_RESET_PASSWORD = 'pep_reset_password';
export const MESSAGE_PURPOSE__PEP_USERNAME = 'pep_username';

// TECH-2730 Phase 2. The two OTP messages, added after phase 1 merged.
//
// NAMED FOR THE TRAP. `pep_reset_password` is the password-reset LINK sent from
// patient.resolver.ts; `pep_reset_password_code` is the six-digit RECOVERY CODE
// sent from password-reset.service.ts. Likewise `pep_username` lists a
// patient's usernames, while `pep_username_code` is the code that lets them see
// that list. Same journey, different message, different variables - the exact
// shape of confusion MessageTemplateVariables exists to catch.
export const MESSAGE_PURPOSE__PEP_RESET_PASSWORD_CODE =
  'pep_reset_password_code';
export const MESSAGE_PURPOSE__PEP_USERNAME_CODE = 'pep_username_code';
// The registration OTP, sent from auth.service.ts. Unlike every other PEP
// message this one fires BEFORE a patient identity exists, so it resolves only
// when the patient arrived with a signed entry token - see
// resolve-patient-id-from-token.ts.
export const MESSAGE_PURPOSE__PEP_REGISTRATION_CODE = 'pep_registration_code';

export const PEP_MESSAGE_PURPOSES = [
  MESSAGE_PURPOSE__PEP_SIGNUP,
  MESSAGE_PURPOSE__PEP_LOGIN,
  MESSAGE_PURPOSE__PEP_RESET_PASSWORD,
  MESSAGE_PURPOSE__PEP_USERNAME,
  MESSAGE_PURPOSE__PEP_RESET_PASSWORD_CODE,
  MESSAGE_PURPOSE__PEP_USERNAME_CODE,
  MESSAGE_PURPOSE__PEP_REGISTRATION_CODE,
];

// TECH-2730 (MR review). Project communications, configured in the Project
// Wizard. This is exactly the set MESSAGE_PURPOSES held before this ticket.
//
// The system purposes below — nine of them now, six before phase 2 added the
// three OTP codes — were appended to MESSAGE_PURPOSES, which is
// also the enum on the PROJECT-level TextMessageTemplates schema and on the
// project template API — so a project template could be saved with
// purpose 'pep_signup' or 'signup', which no send path ever selects and
// validateTemplateVariables does not cover. Keeping the two sets apart makes
// each schema say what it actually accepts.
export const PROJECT_MESSAGE_PURPOSES = [
  MESSAGE_PURPOSE__REMIND_ABOUT_QUESTIONNAIRE,
  MESSAGE_PURPOSE__GREET_PATIENT,
  MESSAGE_PURPOSE__NOTIFY_ABOUT_COMPLETION,
  MESSAGE_PURPOSE__OTHER,
  MESSAGE_PURPOSE__RESPONSES_REVIEW,
];

// System messages, organisation-level, edited on Settings -> Message
// templates: the two zedoc staff account messages and the SEVEN PEP ones —
// nine in all. This said "four PEP" until phase 2 added the three OTP codes;
// the array below is the source of truth, not this sentence.
export const SYSTEM_MESSAGE_PURPOSES = [
  MESSAGE_PURPOSE__SIGNUP,
  MESSAGE_PURPOSE__RESET_PASSWORD,
  ...PEP_MESSAGE_PURPOSES,
];

// TECH-2730 (MR review round 8). There is deliberately NO combined
// MESSAGE_PURPOSES export. The split exists so a project template cannot be
// saved with a system purpose and the reverse; a union that spans both sets is
// the one enum that would let that through again, and nothing imported it --
// every consumer reads PROJECT_MESSAGE_PURPOSES, SYSTEM_MESSAGE_PURPOSES or
// PEP_MESSAGE_PURPOSES. A caller that genuinely needs both should spread the
// two it means, at the point it means them.
